import React, { useState, useEffect } from 'react';

import styles from "./migration.module.scss";
import BarGraph from '../common/graph/BarGraph';
import { formatNumberWithDot } from '../../hooks/utils';
import { migrationData } from "../data/migration_data";


const MigrationGraph = () =>{
    const [worldMigrationsData, setWorldMigrationsData] = useState([]);
    const [maxValue, setMaxValue] = useState();

    useEffect(() => {
        if (migrationData) {
            const dataMax = migrationData.reduce((a, b) => a = a > b.HNWIsMigrated ? a : b.HNWIsMigrated, 0);
            setWorldMigrationsData(migrationData);
            setMaxValue(dataMax);
        }
    }, []);


    const renderTableRow = (item) =>{
     
        let barWidth = Math.round(item.HNWIsMigrated / maxValue * 100);
        // let comparisonValue = item.comparisonLastYearNumber;
        // let comparisonPercent = item.comparisonLastYearPercent;
        let barColor = '';
        let borderDashed = false;

        // if(comparisonValue < 0){
        //     textColor = '#D86F6F';
        // }

        if(item.year === '2023' || item.year === '2024'){
            barColor = '#C5C6C8';
        }else if(item.year === '2022'){
            borderDashed = true;
        }

        return(
            <tr key={item.year} className={borderDashed ? styles.borderBottomDashed : ''}>
                <td className={styles.yearColumn}>{item.year}<span className={styles.notes}>{item.notes}</span></td>
                <td className={styles.barChartColumn}>
                    <BarGraph barWidth={barWidth} barColor={barColor} />
                </td>
                {/* <td className="text-right" style={{'color': textColor}}>{comparisonValue !== 0 ? formatNumber(comparisonValue) : ''}</td>
                <td className="text-right" style={{'color': textColor}}>{comparisonPercent !== 0 ? formatPercentage(comparisonPercent) : ''}</td> */}
                <td className={`text-right ${styles.valueColumn}`}>{formatNumberWithDot(item.HNWIsMigrated)}</td>
            </tr>
        );
    }


    return(
        <div className="appContainer">
            <div className="container-fluid px-0">

                    <p className="mb-5">The data reflects the total number of dollar millionaires who have moved to a new country year on year since 2013 — namely, those who have relocated and remained in a new country for longer than six months. There was a steady growth trajectory until 2020, when the Covid-19 pandemic hampered the migration and tracking of millionaires on the move. Recovery commenced rapidly in 2022, and the 2023 and 2024 forecasts indicate continued growth.</p>

                    <table className={`${styles.table} ${styles.migrationGraphTable}`}>
                        <thead>
                            <tr>
                                <th className={styles.citynameColumn}>Year</th>
                                <th></th>
                                {/* <th colSpan={2} className="text-right">Comparison vs previous year</th> */}
                                <th className="text-right">No. of HNWIs that Migrated</th>
                            </tr>
                        </thead>
                        <tbody>
                        {worldMigrationsData &&
                        worldMigrationsData.map((item) =>
                            renderTableRow(item)
                        )}
                        </tbody>
                    </table>

                    <div className={`${styles.footerNote} mt-5`}>
                    <ul>
                        <li>The 2023 migration forecasts are based on year-to-date HNWI movements to June 2023.</li>
                        <li>HNWI figures rounded to nearest 1,000.</li>
                        <li>‘Millionaires’ or ‘high-net-worth individuals’ or ‘HNWIs’ refer to individuals with investable wealth of USD 1 million or more.</li>
                    </ul>
                    <p>Source: New World Wealth</p>
                </div>
            </div>
           
        </div>
    );
}

export default MigrationGraph;